import { AfterViewChecked, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from '@app/services/_index';
import { StaticPage } from '@app/models/_index';
import { Subscription } from 'rxjs';
import { logGoogleAnalytics } from '@app/utilities/_index';

@Component({
  selector: 'app-elearning-static',
  templateUrl: './elearning-static.component.html',
  styleUrls: ['./elearning-static.component.scss'],
  standalone: false,
})

/**
 * Shared component for both Beyond DX and Genesys Cloud Elearning Component
 */
export class ElearningStaticComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input() elearningStaticPage: [];
  @Input() currentSlugPage: string;
  showNav = false;
  fragment: string;
  hasAnalyticsBeenCalled = false;

  subs: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}

  /**
   * On Init, load elearning static page data
   */
  ngOnInit(): void {
    // The fragment allows the link # page jump to jump to specific content on page
    this.subs.push(
      this.route.fragment.subscribe((fragment: string) => {
        this.fragment = fragment;
      })
    );
  }

  /**
   * On Toggle to display/hide table of contents
   */
  onToggleNavigation(): void {
    this.showNav = !this.showNav;
    this.fragment = '';
  }

  /**
   * Send the query search label to Google Analytics
   * @param category - the source of the google analytics category string (ex. the page or component triggering the action)
   * @param action - the action to be (ex. click)
   * @param dataLabel - the label associated with the action
   */
  sendGoogleAnalytics(category: string, action: string, dataLabel: string): void {
    logGoogleAnalytics(category, action, dataLabel);
    this.googleAnalyticsService.sendEvent(category, action, dataLabel);
  }

  /**
   * On After View checked, Scroll to View using fragment or link a href # alias
   */
  ngAfterViewChecked(): void {
    if (this.fragment) {
      const linkFragment = document.querySelector('#' + this.fragment) as HTMLAnchorElement;
      if (linkFragment) {
        // TODO: Refactor to use scrolling utilities
        linkFragment.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (!this.hasAnalyticsBeenCalled) {
          // NOTE: Fire this send analytics once, else it will also fire for every fragment;
          this.sendGoogleAnalytics('cms', 'click', linkFragment.innerText);
          this.hasAnalyticsBeenCalled = !this.hasAnalyticsBeenCalled;
        }
      }
    }
  }

  /**
   * Add Track By Elearning Static Page Id to not redraw or re-render list items that have not changed.
   * This improves performance.
   * @param index - Index of ElearningStaticPage array
   * @param elearningStaticPage - elearningStaticPage item
   * @returns elearningStaticPage id
   */
  trackByElearningStaticPageId(index: number, elearningStaticPage: StaticPage): number {
    if (elearningStaticPage) {
      return elearningStaticPage.id;
    } else {
      return index;
    }
  }

  /**
   * On Destroy, unsubscribe subscriptions to prevent memory leaks
   */
  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
